import OrderDetailSearchView from '../../../modules/customer-service/containers/order-detail-search-view';
import OrderDetails from '../../../modules/customer-service/containers/order-details';

export default {
  path: ':organization/orders',
  childRoutes: [{
    path: 'search',
    component: OrderDetailSearchView,
    title: 'Customer Service',
  }, {
    path: ':number',
    component: OrderDetails,
    title: 'Order Details',
  }],
};
